const font = {
  size: 12,
  color: { argb: '000000' },
};

const style = {
  alignment: { horizontal: 'center', vertical: 'middle' },
  font,
  border: {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  },
};

export const HEADER_EXCEL_CASES_RESUME = [
  { header: 'CÓDIGO DEL CASO', key: 'codigo', width: 35, style },
  { header: 'UNIDAD', key: 'unidad', width: 35, style },
  { header: 'TIPO DE CASO', key: 'tipo_caso', width: 35, style },
  { header: 'ESTADO', key: 'estado', width: 35, style },
  { header: 'USUARIO ASIGNADO', key: 'usuario', width: 35, style },
  { header: 'CREADO POR', key: 'creado', width: 35, style },
  { header: 'TIEMPO DE PROCESAMIENTO(H)', key: 'tiempo', width: 35, style },
  { header: 'FECHA DE CREACIÓN', key: 'fecha', width: 35, style },
  { header: 'FECHA DE ACTUALIZACIÓN', key: 'fechaA', width: 35, style },
  { header: 'FECHA DE FINALIZACIÓN', key: 'fechaF', width: 35, style },
  { header: 'MONTO RIESGO', key: 'montoR', width: 35, style },
  { header: 'MONTO RECUPERADO', key: 'montoRe', width: 35, style },
  { header: 'MONTO SALVADOS', key: 'montoS', width: 35, style },
  { header: 'MONTO RECLAMO', key: 'montoRecla', width: 35, style },
  { header: 'MONTO RETENIDO', key: 'montoReten', width: 35, style },
];
